module.exports = __webpack_public_path__ + "media/images/flags/4x3/yem-f5eed2e9ba167ce15b5ac8248507b0d3.svg";